import { Actions, createStore } from '@bpd-library/utilities';

interface SmartSubscriptionInterface {
    projectPhaseId?: string;
    districtId?: string;
    title?: string;
    area?: string;
    name?: string;
}

export interface SmartSubscriptionState {
    project: SmartSubscriptionInterface;
}

type SmartSubscriptionStoreAction = 'updateProject';

const initialState: SmartSubscriptionState = {
    project: {
        projectPhaseId: undefined,
        districtId: undefined,
        title: undefined,
        area: undefined,
        name: undefined,
    },
};

const actions: Actions<SmartSubscriptionStoreAction, SmartSubscriptionState> = {
    updateProject: (state: SmartSubscriptionState, project: SmartSubscriptionInterface) => {
        state.project = project;
        return state;
    },
};

export const smartSubscriptionStore = createStore<
    SmartSubscriptionState,
    SmartSubscriptionStoreAction
>({
    initialState,
    actions,
});

export const updateSmartSubscriptionProject = (project: SmartSubscriptionInterface) => {
    smartSubscriptionStore.dispatch('updateProject', project);
};

export const getSmartSubscriptionProject = () => smartSubscriptionStore.getState().project;
